<template>
    <transition name="modal">
        <div v-if="showModal">
            <div class="modal-mask">
                <div class="modal-wrapper" @click="hideIfOverlay" ref="overlay">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        defaultShowModal: {
            type: Boolean,
            default: true,
        },
        dismissOnOverlay: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            showModal: this.defaultShowModal,
        };
    },
    methods: {
        hideIfOverlay(event) {
            if (event.target === this.$refs.overlay) {
                if (this.dismissOnOverlay) {
                    this.dismiss();
                } else {
                    this.close();
                }
            }
        },
        show() {
            this.showModal = true;
        },
        close() {
            this.showModal = false;
        },
        dismiss() {
            this.showModal = false;
            this.$router.push({ name: 'home' });
        },
    },
};
</script>

<style lang="scss"></style>
